import React from 'react';
import '../../less/mobile';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import palette from 'guideline';
import MainHeaderMenu from "./components/MainHeaderMenu";
import InsideHeaderMenu from "./components/InsideHeaderMenu";
import LogoLink from '../../views/logoLink.c';

export default function template() {
  const { homeUrl, navigate } = this.props;
  const { isOpened, headerMenu } = this.state;

  let Component = null;

  switch (headerMenu) {
    case 'cards':
    case 'deposits':
    case 'credit':
    case 'services':
    case 'business':
    case 'businessCalculations':
    case 'businessTrade':
    case 'businessFreeMoney':
    case 'businessFinancing':
    case 'businessGov':
      Component = InsideHeaderMenu;
      break;
    case 'main':
      Component = MainHeaderMenu;
      break;
    default:
      Component = MainHeaderMenu;
  }

  let menu = null;

  if (isOpened) {
    menu = (
      <CSSTransition
        classNames="module-header-mobile__menu"
        timeout={palette.transitionDurationNumber}
      >
        <Component {...this.props} toggle={this.toggle} changeMenu={this.changeMenu} activeMenu={headerMenu}/>
      </CSSTransition>
    );
  }

  return (
    <React.Fragment>
      <TransitionGroup component={null}>{menu}</TransitionGroup>
      <div className="module-header-mobile">
        <div className="mobile-header-top">
          <div className="container">
            <div className="mobile-header-top__left left-mobile-header-top">
              <LogoLink 
                homeUrl={homeUrl} 
                navigate={navigate} 
                className="left-mobile-header-top__logo" 
                additionalClickHandler={isOpened ? this.toggle : undefined}
              />
            </div>
            <div className={`icon-menu__wrapper ${isOpened ? 'active' : ''}`} onClick={this.toggle} onKeyDown={(e) => e.key === 'Enter' && this.toggle} tabIndex="0">
              <div className={`icon-menu ${isOpened ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
